import { render, staticRenderFns } from "./AddTerminal.vue?vue&type=template&id=22d04bd8&"
import script from "./AddTerminal.vue?vue&type=script&lang=js&"
export * from "./AddTerminal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports